import React from "react";

import LogoutScreen from "@/screens/Settings/LogoutScreen";

export default function Index(): React.JSX.Element {
  return <LogoutScreen />;
}
